"use strict";

function t2p(t) {
    return (33554432 * (1.0 - Math.log(Math.tan(0.25 * Math.PI * (t / 90.0 + 1.0))) / Math.PI));
}

function n2p(n) {
    return (33554432 * (1.0 + n / 180.0));
}

var st = new Date();

var cmt = 0;
var fn = 49;
var rs = 2;
var rt = 2;
var sf = 0;

var map;
var playBtn;
var weatherMap;
var weatherOverlay;
var meteoLatLon;

var minZ = 2;
var maxZ = 10;
var topZ = 18;

var posX = n2p(serverVariables.lon);
var posY = t2p(serverVariables.lat);
var posZ = serverVariables.zoom;
var saver;

var fr = new Array(fn);

var md;
var ctimer;
var stimer;
var tiles = {};
var painter = document.createElement("canvas");
var canvas = painter.getContext("2d");
var overlay = document.createElement("canvas");
var overlay2d = overlay.getContext("2d");

function WeatherOverlay(boundsSW, boundsNE, image, map) {
    this.sw = boundsSW;
    this.ne = boundsNE;

    this.image_ = image;
    this.map_ = map;

    this.div_ = null;
    this.img_ = null;

    this.opacity = 0.6;
    this.visible = true;

    this.setMap(map);
}

WeatherOverlay.prototype = new google.maps.OverlayView();

WeatherOverlay.prototype.onAdd = function() {
    var div = document.createElement("div");
    div.style.border = "none";
    div.style.borderWidth = "0px";
    div.style.position = "absolute";

    var img = document.createElement("img");

    img.src = this.image_;
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.position = "absolute";
    img.style.opacity = this.opacity;

    div.appendChild(img);
    this.div_ = div;
    this.img_ = img;

    var panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
}

WeatherOverlay.prototype.draw = function() {
    var overlayProjection = this.getProjection();

    var swp = overlayProjection.fromLatLngToDivPixel(this.sw);
    var nep = overlayProjection.fromLatLngToDivPixel(this.ne);

    if(this.ne.lng() - this.sw.lng() >= 360) {
        var swpdx, nepdx, sx, nx, xx;
        var wx = weatherMap.clientWidth >> 1;
        var dx = overlayProjection.getWorldWidth() / 360;

        swpdx = wx - (map.getCenter().lng() - this.sw.lng()) * dx;
        nepdx = wx - (map.getCenter().lng() - this.ne.lng()) * dx;

        sx = swpdx - nepdx + nep.x;
        nx = nepdx - swpdx + swp.x;

        if(nx > weatherMap.clientWidth - sx) {
            swp.x = sx;
        }
        else {
            nep.x = nx;
        }

        if(nep.x < wx) {
            swp.x += overlayProjection.getWorldWidth();
            nep.x += overlayProjection.getWorldWidth();
        }
        else if(swp.x > wx) {
            swp.x -= overlayProjection.getWorldWidth();
            nep.x -= overlayProjection.getWorldWidth();
        }
    }

    var div = this.div_;

    div.style.left = (swp.x | 0) + "px";
    div.style.top = (nep.y | 0) + "px";
    div.style.width = ((nep.x - swp.x) | 0) + "px";
    div.style.height = ((swp.y - nep.y) | 0) + "px";
}

WeatherOverlay.prototype.onRemove = function() {
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
    this.img_ = null;
}

WeatherOverlay.prototype.hide = function() {
    if(this.div_) {
        this.div_.style.visibility = "hidden";
        this.visible = false;
    }
}

WeatherOverlay.prototype.show = function() {
    if(this.div_ && !this.visible) {
        this.div_.style.visibility = "visible";
        this.visible = true;
    }
}

WeatherOverlay.prototype.adjust = function(boundsSW, boundsNE) {
    if((!this.sw.equals(boundsSW)) || (!this.ne.equals(boundsNE))) {
        this.sw = boundsSW;
        this.ne = boundsNE;
        this.draw();
    }
}

WeatherOverlay.prototype.setImage = function(imageUrl) {
    if(this.img_) {
        this.img_.src = imageUrl;
    }
}

WeatherOverlay.prototype.overlayImage = function(imageUrl, idx) {
    var imageOverlay = new Image();
    var overlayProjection = this.getProjection();

    var swp = overlayProjection.fromLatLngToContainerPixel(this.sw);
    var nep = overlayProjection.fromLatLngToContainerPixel(this.ne);

    if(nep.x < swp.x) {
        nep.x += overlayProjection.getWorldWidth();
    }

    imageOverlay.src = imageUrl;
    imageOverlay.onload = function() {
        overlay2d.globalCompositeOperation = "copy";
        overlay2d.drawImage(imageOverlay, 0, 0, overlay.width, overlay.height);

        var n = painter.width * painter.height;
        var id = overlay2d.getImageData(0, 0, painter.width, painter.height);
        var im = new Uint32Array(id.data.buffer);

        for(var i = n - 1; i >= 0; --i) {
            if(md[i] == 0xff000000) im[i] = 0xff000000;
        }

        overlay2d.putImageData(id, 0, 0);

        fr[idx].p = overlay.toDataURL();

        if(map.getMapTypeId() != google.maps.MapTypeId.HYBRID) {
            weatherOverlay.update(fr[idx].sw, fr[idx].ne, fr[idx].p);
            weatherOverlay.img_.style.opacity = 1.0;
        }
        else {
            weatherOverlay.update(fr[idx].sw, fr[idx].ne, fr[idx].o);
            weatherOverlay.img_.style.opacity = 0.6;
        }

        weatherOverlay.show();
    }
}

WeatherOverlay.prototype.update = function(boundsSW, boundsNE, imageUrl) {
    this.adjust(boundsSW, boundsNE);
    this.setImage(imageUrl);
}

function encodeIndex(x, y, z) {
    var ndx = normaliseIndices(x, y, z);
    x = ndx[0]; y = ndx[1]; z = ndx[2];
    return x + "," + y + "," + z;
}

function decodeIndex(t) {
    return t.split(",", 3);
}

function render() {
    var z = posZ;
    var mp = Math.pow(2, topZ - z);

    var w = painter.width * mp;
    var h = painter.height * mp;
    var sz = 256 * mp;

    var xMin = posX - w / 2;
    var yMin = posY - h / 2;
    var xMax = posX + w / 2;
    var yMax = posY + h / 2;
    var szmx = Math.ceil(xMax / sz);
    var szmy = Math.ceil(yMax / sz);

    for(var x = Math.floor(xMin / sz) ; x < szmx; ++x) {
        var xoff = (x * sz - xMin) / mp;

        for(var y = Math.floor(yMin / sz) ; y < szmy; ++y) {
            var yoff = (y * sz - yMin) / mp;
            var tileKey = encodeIndex(x, y, z);

            if(tiles[tileKey] && tiles[tileKey].complete) {
                canvas.drawImage(tiles[tileKey], Math.round(xoff), Math.round(yoff));
            }
            else {
                if(!tiles[tileKey]) {
                    tiles[tileKey] = new Image();
                    tiles[tileKey].src = tileString(x, y, posZ);
                    tiles[tileKey].onload = function() {
                        render();
                    }
                }

                canvas.fillStyle = "#ffffff";
                canvas.fillRect(Math.round(xoff), Math.round(yoff), 256, 256);
            }
        }
    }

    md = new Uint32Array(canvas.getImageData(0, 0, painter.width, painter.height).data.buffer);
}

function toggleFullScreen() {
    if(!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        if(document.documentElement.requestFullscreen) document.documentElement.requestFullscreen();
        else if(document.documentElement.msRequestFullscreen) document.documentElement.msRequestFullscreen();
        else if(document.documentElement.mozRequestFullScreen) document.documentElement.mozRequestFullScreen();
        else if(document.documentElement.webkitRequestFullscreen) document.documentElement.webkitRequestFullscreen();
    }
    else {
        if(document.exitFullscreen) document.exitFullscreen();
        else if(document.msExitFullscreen) document.msExitFullscreen();
        else if(document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if(document.webkitExitFullscreen) document.webkitExitFullscreen();
    }
}

//
// meteogram
//

$(function() {
    var listener = null;

    var off = function() {
        map.setOptions({ draggableCursor: "move" });
        google.maps.event.removeListener(listener);
        listener = null;
    };

    var on = function() {
        map.setOptions({ draggableCursor: "crosshair" });
        listener = google.maps.event.addListener(map, "click", function(event) {
            var mgUrl = new Url("getProMeteogram.aspx", {
                uid: serverVariables.userName,
                pass: serverVariables.password,
                res: rs,
                lon: (event.latLng.lng() * 1000) | 0,
                lat: (event.latLng.lat() * 1000) | 0,
                sea: 1
            }).toString();
            ng.set("waiting", true);
            $(".meteogram-image").on("load", function() {
                $(".meteogram-overlay").show();
                $(".meteogram").show();
                ng.set("waiting", false);
                off();
            }).attr("src", mgUrl);
        });
    }

    $("#forecast-meteogram").click(function() {
        if(listener == null)
            on();
        else
            off();
    });

    $(".meteogram-close-button").click(function() {
        $(".meteogram").hide();
        $(".meteogram-overlay").hide();
    });
});

//
// zooming
//

function zoomIn() {
    if(posZ < maxZ) {
        map.setZoom(posZ + 1);
    }
}

function zoomOut() {
    if(posZ > minZ) {
        map.setZoom(posZ - 1);
    }
}

function closeResAreaDlg() {
    $("#resoverlay").fadeOut(200);
    $("#resbox").hide();
}

function execResAreaDlg() {
    $("#resoverlay").height(window.innerHeight).fadeTo(200, 0.8);
    $("#resbox").show();
}

// Google maps tiles normalization
function getNormalizedCoord(coord, zoom) {
    var y = coord.y;
    var x = coord.x;

    // tile range in one direction range is dependent on zoom level
    // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
    var tileRange = 1 << zoom;

    // do not repeat across y-axis (vertically)
    if(y < 0 || y >= tileRange) {
        return null;
    }

    // repeat across x-axis
    if(x < 0 || x >= tileRange) {
        x = (x % tileRange + tileRange) % tileRange;
    }

    return { x: x, y: y };
}

function mod(a, b) {
    return ((a % b) + b) % b;
}

function normaliseIndices(x, y, z) {
    return [mod(x, Math.pow(2, z)), mod(y, Math.pow(2, z)), z];
}

function tileString(x, y, z) {
    var ndx = normaliseIndices(x, y, z);
    x = ndx[0]; y = ndx[1]; z = ndx[2];
    var url = "tiles/" + z + "/" + x + "/" + y + ".png";
    return url;
}

function initialize() {
    var konaOptions = {
        getTileUrl: function(coord, zoom) {
            var normalizedCoord = getNormalizedCoord(coord, zoom);

            if(!normalizedCoord) {
                return null;
            }

            var bound = Math.pow(2, zoom);

            return tileString(normalizedCoord.x, normalizedCoord.y, zoom);
        },
        tileSize: new google.maps.Size(256, 256),
        maxZoom: 10,
        minZoom: 2,
        name: "Plain"
    };

    var konaMapType = new google.maps.ImageMapType(konaOptions);

    var mapOptions = {
        center: new google.maps.LatLng(serverVariables.lat, serverVariables.lon),
        draggableCursor: "move",
        mapTypeControl: true,
        mapTypeControlOptions:
        {
            mapTypeIds: [google.maps.MapTypeId.HYBRID, "Plain"],
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        mapTypeId: (serverVariables.mapID == 0) ? google.maps.MapTypeId.HYBRID : "Plain",
        overviewMapControl: false,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
        zoom: posZ,
        zoomControl: false
    };

    weatherMap = document.getElementById("weatherMap");

    map = new google.maps.Map(weatherMap, mapOptions);
    map.mapTypes.set("Plain", konaMapType);
    map.minZoom = minZ;
    map.maxZoom = maxZ;

    google.maps.event.addListener(map, "zoom_changed", function() {
        posZ = map.getZoom();
        if(ctimer) {
            clearTimeout(ctimer);
            ctimer = null;
        }
    });

    google.maps.event.addListener(map, "bounds_changed", function() {
        posX = n2p(map.getCenter().lng());
        posY = t2p(map.getCenter().lat());
        if(ctimer) clearTimeout(ctimer);
        ctimer = setTimeout(render, 1000);
        settings.save();
    });

    google.maps.event.addListener(map, "dragend", function() {
        posX = n2p(map.getCenter().lng());
        posY = t2p(map.getCenter().lat());
        if(ctimer) {
            clearTimeout(ctimer);
            ctimer = null;
        }
        render();
    });

    google.maps.event.addListener(map, "maptypeid_changed", function(event) {
        animation.redraw();
        settings.save();
    });

    google.maps.event.addListener(map, "tilesloaded", function(event) {
        $("#weatherMap")[0].firstChild.firstChild.firstChild.firstChild.style.zIndex = 200;
    });

    // insert naming overlay
    map.overlayMapTypes.insertAt(10, new NameMapOverlay(new google.maps.Size(256, 256)));
    painter.height = weatherMap.clientHeight;
    painter.width = weatherMap.clientWidth;
    overlay.height = weatherMap.clientHeight;
    overlay.width = weatherMap.clientWidth;

    render();
}

//
// The 2nd tileset
// https://developers.google.com/maps/documentation/javascript/maptypes#OverlayMapTypes

var NameMapOverlay = (function() {
    function NameMapOverlay(tileSize) {
        this.tileSize = tileSize;
    }

    NameMapOverlay.prototype.getTile = function(coord, zoom, ownerDocument) {
        var img = $(ownerDocument.createElement("img"));
        img.width(this.tileSize.width);
        img.height(this.tileSize.height);
        var x = coord.x;
        var y = coord.y;
        var n = normaliseIndices(x, y, zoom);
        img.attr("src", "/pro2/objects/" + n[2] + "/" + n[0] + "/" + n[1] + ".png");
        return img[0];
    };

    return NameMapOverlay;
})();

google.maps.event.addDomListener(window, "load", initialize);

window.addEventListener("resize", function() {
    document.getElementById("progressbar-container").style.left = ((window.innerWidth * 0.08) | 0) + "px";

    painter.width = weatherMap.clientWidth;
    painter.height = weatherMap.clientHeight;
    overlay.height = weatherMap.clientHeight;
    overlay.width = weatherMap.clientWidth;

    render();
});

//
// KeyScale
//

var keyScale = (function() {
    function KeyScale() {
        this._el = $("#keyscale");
    }

    KeyScale.prototype.show = function(meteo) {
        var ks = {
            1: "wind",
            2: "pressure",
            4: "precipitation",
            7: "precipitation",
            8: "temperature",
            16: "wave",
            32: "sst",
            64: "tidalStream",
            128: "nexrad"
        }[meteo];

        (ks ? function(el) { el.attr("src", "pub/img/ks/" + ks + ".png").show(); }
            : function(el) { el.hide(); }
         )(this._el);
    }

    KeyScale.prototype.hide = function() {
        this._el.hide();
    }

    return new KeyScale();
})();

//
// Downloader
//

var downloader = (function() {
    function Downloader() {
        this._Limit = 6;
        this._FailureLimit = 3;
        this._frames = null;
        this._failed = null;
        this._id = 0;
        this._paused = false;
        this._scheduled = null;
    }

    Downloader.prototype.start = function(sf) {
        this._frames = [];
        this._failed = [];
        this._id++;
        this._paused = false;

        this._scheduled = [];
        for(var i = sf, j = 0; i < fn && j < this._Limit; i++, j++) {
            this._scheduled.push(i);
        }

        this._pm();
    }

    Downloader.prototype.setNext = function(i) {
        this._scheduled = [];
        for(var k = i, j = 0; k < fn && j < this._Limit; k++, j++) {
            this._scheduled.push(k);
        }
        if(this._paused) {
            this._paused = false;
            this._pm();
        }
    }

    Downloader.prototype.reset = function() {
        this._frames = null;
        this._id++;
        this._scheduled = null;
        this._paused = false;
    }

    Downloader.prototype._pm = function() {
        if(!this._frames) {
            this._paused = true;
            return;
        }

        // check if there's some scheduled downloads
        if(this._scheduled.length == 0) {
            this._paused = true;
            return;
        }

        // now we choose the next frame to download
        var found = false;
        var next = null;
        while(this._scheduled.length > 0) {
            next = this._scheduled[0];
            this._scheduled.splice(0, 1);
            if(!this._frames[next] && !this._failed[next]) {
                found = true;
                break;
            }
        }
        if(!found) {
            this._paused = true;
            return;
        }

        var sw, ne;
        var bounds = map.getBounds();

        if(bounds.toSpan().lng() >= 360) {
            var RAD2DEG = 180 / Math.PI;
            var DEG2RAD = Math.PI / 180;
            var PI_2 = Math.PI / 2;
            var PI_4 = Math.PI / 4;
            var wh2 = weatherMap.clientWidth >> 1;
            var ht2 = weatherMap.clientHeight >> 1;
            var cT = map.getCenter().lat() * DEG2RAD;
            var cN = map.getCenter().lng();
            var radius = 128 * Math.pow(2, posZ - 1);
            var nDiameter = radius << 1;
            var pixel2Deg = 180 / nDiameter;
            var pixel2Rad = Math.PI / nDiameter;
            var yCenterOffset = Math.log(Math.tan(PI_4 + cT / 2)) / pixel2Rad;

            sw = new google.maps.LatLng(RAD2DEG * (2 * Math.atan(Math.exp((ht2 + yCenterOffset - weatherMap.clientHeight + 1) * pixel2Rad)) - PI_2), ((-wh2) * pixel2Deg + cN), true);
            ne = new google.maps.LatLng(RAD2DEG * (2 * Math.atan(Math.exp((ht2 + yCenterOffset) * pixel2Rad)) - PI_2), ((weatherMap.clientWidth - 1 - wh2) * pixel2Deg + cN), true);
        }
        else {
            sw = bounds.getSouthWest();
            ne = bounds.getNorthEast();
        }

        if(weatherOverlay == null) {
            weatherOverlay = new WeatherOverlay(sw, ne, null, map);
        }

        fr[next] = {
            w: null, o: null, p: null, sw: null, ne: null, i: null, x: null, y: null, z: null
        };

        fr[next].sw = sw;
        fr[next].ne = ne;
        fr[next].x = window.innerWidth;
        fr[next].y = window.innerHeight;
        fr[next].z = posZ;

        var c = map.getCenter();
        var lng = c.lng();
        var lat = c.lat();

        if(lng > 180)
            lng = lng % 180;

        if(lng < -180)
            lng = -((-lng) % 180);

        var _this = this;
        var _id = this._id;
        var _nf = next;
        var url = this._getDownloadUrl(
            cmt, rs,
            lng,
            lat,
            posZ,
            window.innerWidth,
            window.innerHeight,
            serverVariables.userName,
            serverVariables.password,
            next
        );
        this._doDownload(url,
            function(data) {
                _this._downloadSuccess(_id, _nf, data);
            },
            function() {
                _this._downloadFailed(_id, _nf);
            },
            this._FailureLimit
        );
    }

    Downloader.prototype._downloadSuccess = function(id, frameid, data) {
        if(this._id != id)
            return;

        var arrayBufferView = new Uint8Array(data);
        var blob = new Blob([arrayBufferView], { type: "image/png" });
        var imageUrl = urlCreator.create(blob);

        fr[frameid].i = data;
        fr[frameid].o = imageUrl;

        // mark as ready
        this._frames[frameid] = true;
        // notify animation
        animation.frameReady(frameid, imageUrl);
        // update progress bar
        pbar.setCached(frameid);
        // load next
        this._pm();
    }

    Downloader.prototype._downloadFailed = function(id, frameid) {
        if(id != this._id)
            return;

        // mark as failed
        this._failed[frameid] = true;
        // notify animation
        animation.frameFailed(frameid);
        // update progress bar
        pbar.setFailed(frameid);
        // load next
        this._pm();
    }

    Downloader.prototype._doDownload = function(url, success, error, retry) {
        var _this = this;
        $.ajax({
            url: url,
            type: "GET",
            dataType: "binary",
            processData: false,
            responseType: "arraybuffer",
            success: function(data) {
                // error emulation
                //if(Math.random() < 0.5) {
                //    error();
                //    return;
                //}
                success(data)
            },
            error: function() {
                if(--retry > 0) {
                    _this._doDownload(url, success, error, retry);
                } else {
                    error();
                }
            }
        });
    }

    Downloader.prototype._getDownloadUrl = function(mt, rs, n, t, z, w, h, u, p, id) {
        switch(mt) {
            case 64:
                return "/pro2/getMapBinaryS.aspx?uid=" + u + "&pass=" + p + "&meteo=" + mt +
                    "&res=" + rs +
                    "&day=" + ((id / 24) | 0) +
                    "&time=" + (id % 24) +
                    "&lat=" + ((t * 1000) | 0) +
                    "&lon=" + ((n * 1000) | 0) +
                    "&radius=" + ((128 * Math.pow(2, z - 1)) | 0) +
                    "&width=" + w + "&height=" + h +
                    "&mode=" + (mt == 7 ? 0 : 1);
            case 128:
                return "/pro2/getMapBinaryS.aspx?uid=" + u + "&pass=" + p + "&meteo=" + mt +
                    "&res=" + rs +
                    "&day=0&time=" + (id % 25) +
                    "&lat=" + ((t * 1000) | 0) +
                    "&lon=" + ((n * 1000) | 0) +
                    "&radius=" + ((128 * Math.pow(2, z - 1)) | 0) +
                    "&width=" + w + "&height=" + h +
                    "&mode=" + (mt == 7 ? 0 : 1);
            default:
                // var stepInMinutes = resInfo(rs).stepInMinutes;
                var stepInMinutes = ng.get("selectedResource").stepInMinutes
                return "/pro2/getMapBinaryS.aspx?uid=" + u + "&pass=" + p + "&meteo=" + mt +
                    "&res=" + rs +
                    "&day=" + ((id * (stepInMinutes / 60) / 24) | 0) +
                    "&time=" + ((id * (stepInMinutes / 60)) % 24) +
                    "&lat=" + ((t * 1000) | 0) +
                    "&lon=" + ((n * 1000) | 0) +
                    "&radius=" + ((128 * Math.pow(2, z - 1)) | 0) +
                    "&width=" + w + "&height=" + h +
                    "&mode=" + (mt == 7 ? 0 : 1);
        }
    }

    return new Downloader();
})();

//
// URL creator
//

var urlCreator = (function() {
    function UrlCreator() {
        this._urlCreator = window.URL || window.webkitURL;
    }

    UrlCreator.prototype.create = function(blob) {
        return this._urlCreator.createObjectURL(blob);
    }

    UrlCreator.prototype.revoke = function(url) {
        return this._urlCreator.revokeObjectURL(url);
    }

    return new UrlCreator();
})();

//
// Clock control
//

var clock = (function() {
    function Clock() {
        this._el = $("#datetime");
    }

    Clock.prototype.reset = function() {
    };

    Clock.prototype.setFrameDate = function(i) {
        this._custom = true;
        this._el.html(ng.get("getDateString")(i - sf));
        var d = new Date();
        console.log("Frame #" + i + " timestamp updated at " +
            d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() +
            "." + d.getMilliseconds()
         );
    }

    return new Clock();
})();

//
// Player control
//

var player = (function() {
    function Player() {
        this._state = null;
        this._backBtn = $("#backBtn");
        this._playBtn = $("#playBtn");
        this._frwdBtn = $("#frwdBtn");
        var _this = this;
        this._backBtn.click(function() { _this._back(); });
        this._playBtn.click(function() { _this._playPause(); });
        this._frwdBtn.click(function() { _this._fwd(); });
    }

    Player.prototype._show = function() {
        this._backBtn.show();
        this._frwdBtn.show();
        this._playBtn.show();
    }

    Player.prototype._hide = function() {
        this._backBtn.hide();
        this._frwdBtn.hide();
        this._playBtn.hide();
    }

    Player.prototype.setState = function(state) {
        this._state = state;
        if(state === "playing") {
            this._playBtn.css({ backgroundImage: "url(pub/img/player/pause.png)" });
            this._show();
            return;
        }
        if(state === "paused") {
            this._playBtn.css({ backgroundImage: "url(pub/img/player/play.png)" });
            this._show();
            return;
        }
        // else
        this._hide();
    }

    Player.prototype._playPause = function() {
        if(this._state === "playing") {
            animation.pause();
            this.setState("paused");
            return;
        }
        if(this._state === "paused") {
            animation.resume();
            this.setState("playing");
            return;
        }
    }

    Player.prototype._back = function() {
        animation.back();
    }

    Player.prototype._fwd = function() {
        animation.fwd();
    }

    return new Player();
})();

//
// animation
//

var animation = (function() {
    function Animation() {
        this._TickerInterval = 50; // ms
        this._FrameInterval = 750; // ms
        this._frames = null;
        this._failed = null;
        this._currentFrame = null;
        this._nextFrame = null;
        this._currentFrameTimeStamp = null;
        this._playing = null;
        this._ticker = null;
    }

    Animation.prototype.start = function(sf) {
        this._frames = [];
        this._failed = [];
        this._nextFrame = sf;
        this._playing = true;

        var _this = this;
        this._ticker = setInterval(function() {
            _this._onTick();
        }, this._TickerInterval);
    }

    Animation.prototype.pause = function() {
        this._playing = false;
        this._nextFrame = null;
    }

    Animation.prototype.resume = function() {
        this._playing = true;
        if(this._currentFrame < fn - 1) {
            this._nextFrame = this._currentFrame + 1;
        } else {
            this._nextFrame = 0;
        }
    }

    Animation.prototype.fwd = function() {
        if(this._currentFrame < fn - 1) {
            this._nextFrame = this._currentFrame + 1;
        }
    }

    Animation.prototype.back = function() {
        if(this._currentFrame > 0) {
            this._nextFrame = this._currentFrame - 1;
        }
    }

    Animation.prototype.goto = function(i) {
        if(i != this._currentFrame && i >= 0 && i < fn) {
            this._nextFrame = i;
        }
    }

    Animation.prototype.frameReady = function(i, url) {
        this._frames[i] = url;
    }

    Animation.prototype.frameFailed = function(i) {
        this._failed[i] = true;
    }

    Animation.prototype.reset = function() {
        if(this._ticker) {
            clearInterval(this._ticker);
            this._ticker = null;
        }
        this._revokeObjectURLs();
        this._frames = null;
        this._failed = null;
        this._currentFrame = null;
        this._nextFrame = null;
        this._currentFrameTimeStamp = null;
        this._playing = null;
    }

    Animation.prototype.redraw = function() {
        if(weatherOverlay && weatherOverlay.img_ && this._currentFrame) {
            if(map.getMapTypeId() != google.maps.MapTypeId.HYBRID) {
                weatherOverlay.update(fr[this._currentFrame].sw, fr[this._currentFrame].ne, fr[this._currentFrame].p);
                weatherOverlay.img_.style.opacity = 1.0;
            }
            else {
                weatherOverlay.update(fr[this._currentFrame].sw, fr[this._currentFrame].ne, fr[this._currentFrame].o);
                weatherOverlay.img_.style.opacity = 0.6;
            }
        }
    }

    Animation.prototype._showNext = function() {
        var i = this._nextFrame;
        if(weatherOverlay == null) {
            weatherOverlay = new WeatherOverlay(fr[i].sw, fr[i].ne, this._frames[i], map);
        } else {
            weatherOverlay.overlayImage(this._frames[i], i);
        }
        this._currentFrame = i;
        this._currentFrameTimeStamp = new Date().valueOf();
    }

    // schedule next frame
    Animation.prototype._scheduleNext = function() {
        if(!this._playing) {
            this._nextFrame = null;
            return;
        }
        // _playing is true
        for(var i = this._nextFrame + 1; i < fn; i++) {
            if(!this._failed[i]) {
                this._nextFrame = i;
                return;
            }
        }
        // we've reached the end
        this._playing = false;
        this._nextFrame = null;
    }

    // update UI
    Animation.prototype._updateUI = function() {
        // update clock
        clock.setFrameDate(this._currentFrame);
        // update progress bar
        pbar.setCurrent(this._currentFrame);
        // update player UI
        player.setState(this._playing ? "playing" : "paused");
    }

    Animation.prototype._onTick = function() {
        // we have a frame to show
        if(this._nextFrame != null) {
            // it's time to show it
            var now = new Date().valueOf();
            var last = this._currentFrameTimeStamp;
            if(last == null || (now - last >= this._FrameInterval)) {
                // if frame ready
                if(this._frames[this._nextFrame]) {
                    // then show it
                    this._showNext();
                    this._scheduleNext();
                    this._updateUI();
                    return;
                }
                if(this._failed[this._nextFrame]) {
                    this._scheduleNext();
                    this._updateUI();
                    return;
                }
                else {
                    // else request loading the frame
                    downloader.setNext(this._nextFrame);
                }
            }
        }
    }

    Animation.prototype._revokeObjectURLs = function() {
        if(this._frames) {
            for(var i = 0; i < this._frames.length; i++) {
                if(this._frames[i]) {
                    urlCreator.revoke(this._frames[i]);
                    this._frames[i] = undefined;
                }
            }
        }
    }

    return new Animation();
})();

//
// PB
//

var pbar = (function() {
    function PBar() {
        this._elContainer = $("#progressbar-container");
        this._elStartText = this._elContainer.find("#progressStartText");
        this._elEndText = this._elContainer.find("#progressFinishText");
        this._elContainer.css({ left: ((window.innerWidth * 0.08) | 0) });
    }

    PBar.prototype._getValue = function(e) {
        var x = e.clientX;
        var w = this._elProgressBar.width();
        var l = this._elContainer.offset().left;
        return ((x - l) * fn / w) | 0;
    }

    PBar.prototype.rebuild = function() {
        this._elStartText.html(ng.get("getDateString")(-sf));
        this._elEndText.html(ng.get("getDateString")(fn - sf - 1));
    }

    PBar.prototype.show = function() {
        this._elContainer.show();
    }

    PBar.prototype.hide = function() {
        this._elContainer.hide();
    }

    PBar.prototype.setCached = function(f) {
        ng.broadcast("pbar_setcached", f);
    }

    PBar.prototype.setCurrent = function(f) {
        ng.broadcast("pbar_setcurrent", f);
    }

    PBar.prototype.setFailed = function(f) {
        ng.broadcast("pbar_setfailed", f);
    }

    return new PBar();
})();

//
// Settings
//

var settings = (function() {
    function Settings() {
        this._active = null;
    }

    Settings.prototype._getSaveUrl = function() {
        var c = map.getCenter();
        var lng = c.lng();
        var lat = c.lat();

        if(lng > 180)
            lng = lng % 180;

        if(lng < -180)
            lng = -((-lng) % 180);

        var s = {
            x: lng,
            y: lat,
            z: posZ,
            r: rs,
            m: (map.getMapTypeId() != google.maps.MapTypeId.HYBRID ? 1 : 0)
        };
        var url = new Url("saveSettings.aspx", s).toString();
        return url;
    }

    Settings.prototype.save = function() {
        var _this = this;
        if(!this._active) {
            this._active = true;
            setTimeout(function() {
                _this._doSave();
                _this._active = false;
            }, 1000);
        }
    }

    Settings.prototype._doSave = function() {
        $.get(this._getSaveUrl());
    }

    return new Settings();
})();

var Url = (function() {
    function Url(base, query) {
        this._base = base || "";
        this._query = $.extend({}, query || {});
    }

    function _formatData(v) {
        if(typeof (v) === "undefined" || v === null)
            v = "";
        return v.toString();
    }

    function _joinQueryKeyValuePair(p) {
        return p.join("=");
    }

    function _joinQueryString(qs) {
        return qs.join("&");
    }

    function _joinUrl(b, qs) {
        return [b, qs].join("?");
    }

    Url.prototype.toString = function() {
        return _joinUrl(this._base, this.getQueryString());
    }

    Url.prototype.getQueryString = function() {
        return _joinQueryString(
            _.map(_.pairs(this._query), _joinQueryKeyValuePair)
        );
    }

    Url.encodeData = function(v) {
        return encodeURIComponent(_formatData(v));
    }

    return Url;
})();

//
// http://www.henryalgus.com/reading-binary-files-using-jquery-ajax/
//

$.ajaxTransport("binary", function(options, originalOptions, jqXHR) {
    // check for conditions and support for blob / arraybuffer response type
    if(window.FormData && ((options.dataType && (options.dataType == 'binary')) ||
        (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
            // create new XMLHttpRequest
            send: function(headers, callback) {
                // setup all variables
                var xhr = new XMLHttpRequest();
                var url = options.url;
                var type = options.type;
                var async = options.async || true;
                // blob or arraybuffer. Default is blob
                var dataType = options.responseType || "blob";
                var data = options.data || null;
                var username = options.username || null;
                var password = options.password || null;

                xhr.addEventListener('load', function() {
                    var data = {
                    };
                    data[options.dataType] = xhr.response;
                    // make callback and send data
                    callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                });

                xhr.open(type, url, async, username, password);

                // setup custom headers
                for(var i in headers) {
                    xhr.setRequestHeader(i, headers[i]);
                }

                xhr.responseType = dataType;
                xhr.send(data);
            },
            abort: function() {
                jqXHR.abort();
            }
        };
    }
});

//
// angular stuff
//

var ng = (function() {
    function _getScope(el) {
        return angular.element(el).scope();
    }

    function _getRoot() {
        return angular.element("html").scope().$root;
    }

    function NG() {
    }

    NG.prototype.broadcast = function(e, args) {
        _getRoot().$apply(function(s) {
            s.$broadcast(e, args);
        });
    };

    NG.prototype.set = function(variable, value) {
        _getScope("html").$apply(function(s) {
            s[variable] = value;
        });
    }

    NG.prototype.get = function(variable) {
        return _getScope("html")[variable];
    }

    NG.prototype.injector = function() {
        return angular.element("html").injector();
    }

    return new NG();
})();
